import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
  admins: [],
  loading: false,
  error: null,
};

const mutations = {
  SET_ADMINS(state, data) {
    state.admins = data;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchAdmins({ commit }, activityId) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await api.post("/manageactivityajax/", {
        cmd: "getadmins",
        activityid: activityId,
      });

      const adminsData = response.data?.output || [];
      commit("SET_ADMINS", adminsData);
      return adminsData;
    } catch (error) {
      const message = handleApiError(error, "Failed to fetch activity admins");
      commit("SET_ERROR", message);
      throw new Error(message);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async saveAdmins({ commit }, { activityId, userIdsArray }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await api.post("/managelocationajax", {
        cmd: "saveadmins",
        activityid: activityId,
        useridsarray: userIdsArray,
      });

      const message = response.data?.message || "Admins saved successfully";
      return { success: true, message };
    } catch (error) {
      const message = handleApiError(error, "Failed to save admins");
      commit("SET_ERROR", message);
      return { success: false, message };
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  activityAdmins: (state) => state.admins,
  activityAdminsLoading: (state) => state.loading,
  activityAdminsError: (state) => state.error,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
